import React, { useState, useEffect } from 'react'
import LanguageIcon from '@material-ui/icons/Language'
import { IconButton, Typography, Menu, MenuItem } from '@material-ui/core'
import CheckIcon from '@material-ui/icons/Check'
import { useTranslation } from 'react-i18next'

function LanguageButton() {
  const { t, i18n } = useTranslation()
  const [language, setLanguage] = useState(null)
  const [anchorEl, setAnchorEl] = useState(null)

  useEffect(() => {
    setLanguage(i18n.language)
  }, [i18n.language])

  const handleLanguageClick = language => {
    i18n.changeLanguage(language)
    handleClose()
  }

  const handleMenu = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <div style={{ marginRight: '5px' }}>
      <IconButton
        aria-label='switch language'
        aria-controls='menu-appbar'
        aria-haspopup='true'
        color='inherit'
        onClick={e => handleMenu(e)}
      >
        <LanguageIcon style={{ marginRight: '5px' }} />
        <Typography variant='subtitle2'>
          {language === 'en' && t('languages:english')}
          {language === 'fr' && t('languages:french')}
        </Typography>
      </IconButton>
      <Menu
        id='menu-appbar'
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={() => handleLanguageClick('en')}>
          {t('languages:english')}
          {language === 'en' && <CheckIcon style={{ marginLeft: '5px' }} />}
        </MenuItem>
        <MenuItem onClick={() => handleLanguageClick('fr')}>
          {t('languages:french')}
          {language === 'fr' && <CheckIcon style={{ marginLeft: '5px' }} />}
        </MenuItem>
      </Menu>
    </div>
  )
}

export default LanguageButton
